import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {CharacterFieldUpdateField} from "../_payload/CharacterFieldUpdateField";
import {CharacterFieldsUpdateMessage} from "../_messages/CharacterFieldsUpdateMessage";
import {s_app_rid, s_app_sl} from "../_signals/s_app";
import CharacterFieldsUpdate from "../_payload/CharacterFieldsUpdate";

export const CharFieldsUpdate = (cid: string, fields: CharacterFieldUpdateField[]) => {
    const update: CharacterFieldsUpdate = {
        cid: cid,
        rid: s_app_rid.value,
        sl: s_app_sl.value,
        fields: fields,
    }
    fetch(apiAddress + "/chars/", createOptions('UPDATE', update))
        .then((res) => res.json())
        .then((data) => console.log('CharFieldsUpdate response', data))
}

export const CharCopy = (cid: string, rid: string) => {
    fetch(apiAddress + "/chars/copy/" + rid + '/' + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => console.log('CharCopy response', data))
}

export const CharDelete = (cid: string, rid: string) => {
    fetch(apiAddress + "/chars/delete/" + rid + '/' + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => console.log('CharDelete response', data))
}